import React, { memo } from 'react';

/**
 * CollapsedContent Component
 * Renders the vertical collapsed view of a column
 */
const CollapsedContent = memo(({
  column,
  taskCount,
  dragListeners,
}) => {
  return (
    <div 
      className="kanban-column__collapsed-content"
      {...(dragListeners || {})}
    >
      {/* Drag handle for collapsed state */}
      <span className="kanban-column__drag-handle kanban-column__drag-handle--collapsed" title="Drag to reorder">
        <svg width="10" height="14" viewBox="0 0 10 14" fill="currentColor">
          <circle cx="2" cy="2" r="1.5" />
          <circle cx="8" cy="2" r="1.5" />
          <circle cx="2" cy="7" r="1.5" />
          <circle cx="8" cy="7" r="1.5" />
          <circle cx="2" cy="12" r="1.5" />
          <circle cx="8" cy="12" r="1.5" />
        </svg>
      </span>
      <span 
        className="kanban-column__color-dot" 
        style={{ background: column.color }}
      />
      <span className="kanban-column__collapsed-label">{column.name}</span>
      <span className="kanban-column__collapsed-count">{taskCount}</span>
    </div>
  );
});

export default CollapsedContent;

